module.exports = __webpack_public_path__ + "static/media/Campus drive.3fce4795.png";